import React, { Component } from 'react'; 
import {Button, Modal, Table, Row, Col} from 'react-bootstrap';
import _ from "lodash";
import Picky from 'react-picky';
import 'react-picky/dist/picky.css';

class EditClient extends Component {
  constructor(props){
     super(props)
      this.state={
      selectedProcess0:[],   
      selectedFrequency0:[],
      selectedValues:[]
    }
  }  
  componentWillMount(){
    const{selected} = this.props;
    const{selectedValues} = this.state
    if(!_.isEmpty(selected)){
    _.map(selected, (obj, i) => {
      if(!_.isEmpty(obj)){
       let index = _.findIndex(this.props.Reports, {'reportName':obj.reportName})
       selectedValues[index] = selected[i]
      }
      })
    }
    this.setState({selectedValues})
  }
  componentDidMount(){
   const{selectedValues} = this.state 
    if(!_.isEmpty(selectedValues)){
    _.map(selectedValues, (val, i) => {
      if(!_.isEmpty(val)){
        let index = _.findIndex(this.props.Reports, {'reportName': val.reportName})
        this.setState({['checked'+index]:true})
        let pindex = _.findIndex(this.props.process, {'inventoryProcessName': val.inventoryProcessName})
        this.setState({['selectedProcess'+index]:this.props.process[pindex]})
        let findex = _.findIndex(this.props.freqlist, {'frequencyName': val.frequencyName}) 
        this.setState({['selectedFrequency'+index]:this.props.freqlist[findex]})  
      }    
      })
    }
  }
  
  handleClose = () => {
    const{selectedValues}  = this.state;
    let x  = _.cloneDeep(selectedValues)
    var filtered = x.filter(function (el) {
      return el != null;
    });
    this.props.callBack(filtered)
    this.props.handleClose()
  }
  handleCheckbox = (e, i, obj) => {
    const {selectedValues} = this.state;
    this.setState({['checked'+i]:e.target.checked})    
    let object = {'reportName':obj.reportName, 'reportId':obj.id, 'status':"ACTIVE"} 
    if(e.target.checked){
      if(!_.isEmpty(selectedValues[i])){
        selectedValues[i] = Object.assign({}, selectedValues[i], object)
      
      } else {
        selectedValues[i] = object
      }

    } else {
      _.pullAt(selectedValues, i)
      this.setState({['selectedProcess'+i]:[], ['selectedFrequency'+i]:[]})
    }
    this.setState({selectedValues})
  }
  handleProcess = (obj, i) => {
    const {selectedValues} = this.state;
    this.setState({['selectedProcess'+i]:obj})
    if(!_.isEmpty(selectedValues)){
      selectedValues[i] = Object.assign({}, selectedValues[i], obj)
    } else {
      selectedValues[i] =  obj
    }
    this.setState({selectedValues})
  }
  showCheckFrequency = (obj, i) => {
    const {selectedValues} = this.state;
    this.setState({['selectedFrequency'+i]:obj})
    let object= {'frequencyName':obj.frequencyName, 'frequencyId':obj.id}
    if(!_.isEmpty(selectedValues)){ 
      selectedValues[i] = Object.assign({}, selectedValues[i], object)
    } else {
      selectedValues[i] =  object
    }
    this.setState({selectedValues})
  }
  handleSelectAll = (event) => {
   const {selectedValues} = this.state;
    _.map(this.props.Reports, (val, i) =>{
      this.setState({['checked'+i]: event.target.checked, 'checkedAll':event.target.checked})
      if(event.target.checked){
        if(!_.isEmpty(selectedValues[i])){
          selectedValues[i] = Object.assign({}, selectedValues[i], this.props.Reports[i])
        } else {
         selectedValues[i] = this.props.Reports[i]
        }
        this.setState({selectedValues})
      } else{     
        this.setState({selectedValues: []})
      }
    })
  } 
   
   
  renderBody = (start, end) => {
    const {Reports, process} = this.props;
    return _.map(Reports, (obj, i) => {
      if(i>=start && i<end){
      return(
        <tr><td><input type='checkbox' checked={this.state['checked'+i]}
        onChange={(e)=>this.handleCheckbox(e, i, obj)} /></td>
        <td>{obj.reportName}</td>
        <td className='reportwidthClass'><Picky keepOpen={false}
            value={this.state['selectedProcess'+i] ? this.state['selectedProcess'+i] :[]}
            options={process}
            onChange={(e)=>this.handleProcess(e, i)}
            open={false}
            valueKey="inventoryProcessName"
            labelKey="inventoryProcessName"
            multiple={false}
            includeSelectAll={false} 
            includeFilter={false}
            placeholder='Select Process'
            dropdownHeight={600}
            />
        </td>
        <td className='reportwidthClass'>
        <Picky keepOpen={false}
          value={this.state['selectedFrequency'+i] ? this.state['selectedFrequency'+i] : []}
          options={this.props.freqlist}
          onChange={(e)=>this.showCheckFrequency(e, i)}
          open={false}
          valueKey="frequencyName"
          labelKey="frequencyName"
          multiple={false}
          includeSelectAll={false} 
          includeFilter={false}
          placeholder='Select Frequency'
          dropdownHeight={600}
        />
        </td>       
        </tr>
      )
      }
    })
  }
  render(){
    let length ;
    if(!_.isEmpty(this.props.Reports)){
      length = this.props.Reports.length;
    }    
    return(
      <Modal
        show={true}
        onHide={this.props.handleClose}
        dialogClassName="modal-120w"
        size="xl"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        >
        <Modal.Header closeButton>
          <Modal.Title>
        Select Reports  and Frequency</Modal.Title>
        </Modal.Header>
        <Modal.Body>
        <div>    
        {length > 20 ?
        <Row>
        <Col>
        <Table responsive>
          <thead>
            <th><input type='checkbox' checked={this.state.checkedAll} onChange={this.handleSelectAll} /></th>
            <th> REPORTS</th>
            <th> PROCESS</th>
            <th> FREQUENCY </th>            
          </thead>
          <tbody>
              {this.renderBody(0, length/2)}
          </tbody>
        </Table>
        </Col>
        <Col>
        <Table responsive>
          <thead>
            <th><input type='checkbox' checked={this.state.checkedAll} onChange={this.handleSelectAll} /></th>
            <th> REPORTS</th>
            <th> PROCESS</th>
            <th> FREQUENCY </th>           
          </thead>
          <tbody>
              {this.renderBody(length/2, length)}
          </tbody>
        </Table>
        </Col></Row>
         : 
        <Table responsive>
          <thead>
            <th><input type='checkbox' checked={this.state.checkedAll} onChange={this.handleSelectAll} /></th>
            <th> REPORTS</th>
            <th> PROCESS</th>
            <th> FREQUENCY </th>        
          </thead>
          <tbody>
              {this.renderBody()}
          </tbody>
        </Table>   
        }
        <Button onClick={this.handleClose} >OK</Button>
        </div>
        </Modal.Body>
        </Modal>
        )
  }
}
export default EditClient
